import _regeneratorRuntime from "/builds/7ChVgkMg/1/gcp-backend/tea-h5/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/builds/7ChVgkMg/1/gcp-backend/tea-h5/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
var _hoisted_1 = {
  class: "forget-password"
};
var _hoisted_2 = {
  class: "title"
};
var _hoisted_3 = {
  class: "form"
};
import PagePopupLayout from "@/layouts/PagePopupLayout.vue";
import { computed, ref } from "vue";
import FormItem from "./form/FormItem.vue";
import { watch } from "vue";
import { changePassword } from "@/api/user";
import { hideLoading, showLoading } from "@/utils/loadingUtil";
import { CODE_INVALID, CODE_ERROR, INCORRECT_USERNAME } from "@/constant/responseCode";
import { Notify } from "@/utils/notifyUtil";
import { getSupplyId } from "@/utils/authUtil";
import md5 from "js-md5";
import { useSupplierStore } from "@/store/supplierStore";
import { useI18n } from "vue-i18n";
export default {
  __name: 'ForgetPasswordStep2Popup',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    phone: {
      type: String,
      required: true
    },
    callcode: {
      type: String,
      required: true
    },
    code: {
      type: String,
      required: true
    }
  },
  emits: ["update:show", "success"],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var _useI18n = useI18n(),
      t = _useI18n.t;
    var supplierStore = useSupplierStore();
    var emit = __emit;
    var isDisabled = computed(function () {
      return !formData.value.password || !formData.value.confirm_password;
    });
    var props = __props;
    var formData = ref({
      password: "",
      confirm_password: ""
    });
    var errorForm = ref({
      password: "",
      confirm_password: ""
    });
    var showPopup = computed({
      get: function get() {
        return props.show;
      },
      set: function set(val) {
        emit("update:show", val);
      }
    });
    watch(showPopup, function (val) {
      if (!val) {
        formData.value = {
          password: "",
          confirm_password: ""
        };
      }
    });
    var checkParams = function checkParams() {
      var flag = true;
      if (formData.value.password.length < 6) {
        errorForm.value.password = t("atLeast6Characters");
        flag = false;
      }
      if (formData.value.confirm_password.length < 6) {
        errorForm.value.confirm_password = t("atLeast6Characters");
        flag = false;
      }
      if (formData.value.confirm_password !== formData.value.password) {
        if (!errorForm.value.password) errorForm.value.password = t("theEnteredPasswordsDoNotMatch");
        if (!errorForm.value.confirm_password) errorForm.value.confirm_password = t("theEnteredPasswordsDoNotMatch");
        flag = false;
      }
      if (flag) {
        errorForm.value.password = "";
        errorForm.value.confirm_password = "";
      }
      return flag;
    };
    var submit = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (checkParams()) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              showLoading();
              _context.next = 5;
              return changePassword({
                phone: props.phone,
                area_code: props.callcode,
                verification_code: props.code,
                new_password: md5(formData.value.password),
                supplier_id: getSupplyId(),
                country: supplierStore.getCountry
              });
            case 5:
              res = _context.sent;
              hideLoading();
              if (res.isOK) {
                emit("success");
                showPopup.value = false;
                Notify.success(t("changeSuccessfully"));
              } else if (res.code === CODE_INVALID || res.code === CODE_ERROR) {
                Notify.error(t("verificationCodeIsInvalid"));
              } else if (res.code === INCORRECT_USERNAME) {
                Notify.error(t("accountDoesNotExist"));
              }
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function submit() {
        return _ref2.apply(this, arguments);
      };
    }();
    return function (_ctx, _cache) {
      var _component_Gap = _resolveComponent("Gap");
      var _component_Button = _resolveComponent("Button");
      return _openBlock(), _createBlock(PagePopupLayout, {
        show: showPopup.value,
        "onUpdate:show": _cache[4] || (_cache[4] = function ($event) {
          return showPopup.value = $event;
        }),
        "content-class": "forget-container"
      }, {
        default: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_1, [_createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$t("forgetPassword")), 1), _createElementVNode("form", _hoisted_3, [_createVNode(FormItem, {
            modelValue: formData.value.password,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
              return formData.value.password = $event;
            }),
            label: _ctx.$t('password'),
            type: "password",
            error: errorForm.value.password,
            onInput: _cache[1] || (_cache[1] = function ($event) {
              return errorForm.value.password = '';
            })
          }, null, 8, ["modelValue", "label", "error"]), _createVNode(_component_Gap, {
            h: 0.2
          }), _createVNode(FormItem, {
            modelValue: formData.value.confirm_password,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
              return formData.value.confirm_password = $event;
            }),
            label: _ctx.$t('confirmPassword'),
            type: "password",
            error: errorForm.value.confirm_password,
            onInput: _cache[3] || (_cache[3] = function ($event) {
              return errorForm.value.confirm_password = '';
            })
          }, null, 8, ["modelValue", "label", "error"])]), _createVNode(_component_Button, {
            class: "btn",
            disabled: isDisabled.value,
            onClick: submit
          }, {
            default: _withCtx(function () {
              return [_createTextVNode(_toDisplayString(_ctx.$t("confirm")), 1)];
            }),
            _: 1
          }, 8, ["disabled"])])];
        }),
        _: 1
      }, 8, ["show"]);
    };
  }
};